module.exports = __webpack_public_path__ + "img/success-confirmation.ce9f751c.svg";